module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4936485ece34a75e07e8be5ac4ed31c8.png";